export const frontendURI = '/cat/workflows/';
export const backendURI = `/api${frontendURI}`;
